import { Navigate, RouteObject } from "react-router";
import LazyRouter from "@/components/LazyRouter";

/**区划管理员路由 */
const region_routers: RouteObject[] = [
    {
        element: <LazyRouter load={() => import("@/pages/layout")} />,
        children: [
            {
                path: "dashboard",
                element: <LazyRouter load={() => import("@/pages/dashboard")} />,
            },
            {
                path: "manage",
                children: [
                    {
                        path: "business",
                        element: <LazyRouter load={() => import("@/pages/manage/business")} />
                    },
                    {
                        path: "cross",
                        element: <LazyRouter load={() => import("@/pages/manage/cross")} />,
                    },
                    {
                        path: "user",
                        element: <LazyRouter load={() => import("@/pages/manage/user")} />,
                    },
                    {
                        path: "record",
                        element: <LazyRouter load={() => import("@/pages/manage/record")} />,
                    },
                    { path: "*", element: <LazyRouter load={() => import("@/pages/404")} /> },
                ]
            },
            {
                path: "items",
                children: [
                    {
                        path: "dept",
                        element: <LazyRouter load={() => import("@/pages/items/dept")} />,
                    },
                    {
                        path: "theme",
                        element: <LazyRouter load={() => import("@/pages/items/theme")} />,
                    },
                    {
                        path: "list",
                        element: <LazyRouter load={() => import("@/pages/items/list")} />,
                    },
                    { path: "*", element: <LazyRouter load={() => import("@/pages/404")} /> },
                ]
            },
            {
                path: "system",
                children: [
                    {
                        path: "news",
                        element: <LazyRouter load={() => import("@/pages/system/news")} />,
                    },
                    { path: "*", element: <LazyRouter load={() => import("@/pages/404")} /> },
                ]
            }
        ]
    },
    { path: "login", element: <LazyRouter load={() => import("@/pages/login")} /> },
    { path: "", element: <Navigate to={"/dashboard"} /> },
];

export default region_routers;